<template>
  <div class="formitemselect-wrap" :class="{ir: isreset}">
    <div class="form-block-item" :class="{ error: error}">
      <label @click="showOptions = !showOptions"><em class="required">*</em>{{label}}</label>
      <div class="value-wrap" @click="showOptions = !showOptions"><span v-if="value && displayLabel">{{ displayLabel }}</span><Icon :name="showOptions ? 'pullup' : 'pulldown'" size="24" /></div>
      
      <span class="errortip">{{LOCAL('error_required_cannot_empty')}}</span>

      <div class="form-block-select-options" v-if="showOptions" :style="{ height: `${options.length * 28 + (options.length - 1) * 12 + 1 + 12}px` }">
        <div class="item" :class="{ active: value == oitem.value }" v-for="(oitem, oindex) in options" @click="selectHandle(oitem, oindex,options.length)" :key="oindex"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{oitem.label}}</span></div>
      </div>
    </div>

    <div class="formitemselect-wrap-bg" @click="showOptions = !showOptions" v-if="showOptions"></div>
  </div>
</template>

<script setup>
  import { ref, onMounted, watch } from 'vue';
  import * as Utils from '@/assets/utils';
  import Icon from '@/components/icon/index.vue';
  import Footer from '@/components/footer/index.vue';
  import { LOCAL, getLangList, getLocalLangCode, setLocalLangCode } from '@/assets/lang/index';

  const emit = defineEmits([ 'change' ]);

  const props = defineProps({
    label: {
      type: String,
      defaultValue: ''
    },
    options: {
      type: Array,
      defaultValue: () => []
    },
    value: {
      type: Number,
      defaultValue: null
    },
    error: {
      type: Boolean,
      defaultValue: false
    },
    isreset: {
      type: Boolean,
      defaultValue: false
    }
  })

  const displayLabel = ref('');
  const initDisplayLabel = () => {
    if(props.options?.length > 0) {
      props.options.map(o => {
        if(o.value == props.value) {
          displayLabel.value = o.label
        }
      })
    }
  }
  watch(() => props.value, () => {
    initDisplayLabel()
  })
  onMounted(() => {
    initDisplayLabel()
  })

  const showOptions = ref(false);

  const selectHandle = (item,oindex, length) => {
    console.log('item', item,'oindex',oindex,'length',length)
    emit('change', [item,oindex, length]);
    showOptions.value = false;
  }
</script>

<style scoped lang="less">
  @import "index.less";
</style>
